import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { MessageSquarePlus, X, Star } from 'lucide-react'
import toast from 'react-hot-toast'
import clsx from 'clsx'
import { submitFeedback } from '../api'

const CATEGORIES = [
  { id: 'bug', label: '🐛 Bug' },
  { id: 'idee', label: '💡 Idée' },
  { id: 'ux', label: '🎨 Retour UX' },
  { id: 'autre', label: '💬 Autre' },
]

export default function FeedbackButton() {
  const [open, setOpen] = useState(false)
  const [category, setCategory] = useState('idee')
  const [message, setMessage] = useState('')
  const [rating, setRating] = useState(0)
  const [sending, setSending] = useState(false)
  const location = useLocation()

  const submit = async () => {
    if (!message.trim()) return toast.error('Écris ton retour')
    setSending(true)
    try {
      await submitFeedback({
        category, message, rating: rating || null, page: location.pathname,
      })
      toast.success('Merci pour ton retour !')
      setMessage(''); setRating(0); setCategory('idee'); setOpen(false)
    } catch {
      toast.error('Erreur envoi')
    } finally {
      setSending(false)
    }
  }

  return (
    <>
      {/* Bouton flottant */}
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-5 right-5 z-40 bg-primary-600 hover:bg-primary-500 text-white rounded-full shadow-xl shadow-primary-600/40 p-3.5 flex items-center gap-2 transition-all"
        title="Donner mon avis"
      >
        <MessageSquarePlus size={20} />
        <span className="hidden sm:inline text-sm font-medium pr-1">Feedback</span>
      </button>

      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div
            className="bg-dark-800 border border-dark-700 rounded-2xl w-full max-w-md shadow-2xl"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b border-dark-700">
              <h3 className="text-dark-50 font-semibold">💬 Ton retour</h3>
              <button onClick={() => setOpen(false)} className="text-dark-400 hover:text-dark-50">
                <X size={18} />
              </button>
            </div>

            <div className="p-4 space-y-3">
              <div className="flex flex-wrap gap-2">
                {CATEGORIES.map(c => (
                  <button
                    key={c.id}
                    onClick={() => setCategory(c.id)}
                    className={clsx(
                      'px-3 py-1.5 rounded-lg text-xs border transition-colors',
                      category === c.id
                        ? 'bg-primary-600/30 border-primary-500 text-primary-200'
                        : 'bg-dark-900/50 border-dark-600 text-dark-400 hover:border-dark-400'
                    )}
                  >
                    {c.label}
                  </button>
                ))}
              </div>

              <textarea
                className="input-field min-h-[110px] resize-y text-sm"
                placeholder="Décris ton bug, ton idée, ce qui te plaît ou pas..."
                value={message}
                onChange={e => setMessage(e.target.value)}
              />

              <div className="flex items-center gap-2">
                <span className="text-dark-400 text-sm">Note la page :</span>
                {[1, 2, 3, 4, 5].map(n => (
                  <button key={n} onClick={() => setRating(n)}>
                    <Star
                      size={18}
                      className={n <= rating ? 'text-yellow-400 fill-yellow-400' : 'text-dark-600'}
                    />
                  </button>
                ))}
              </div>

              <p className="text-dark-500 text-xs">Page : {location.pathname}</p>

              <button onClick={submit} disabled={sending} className="btn-primary w-full justify-center text-sm">
                {sending ? 'Envoi…' : 'Envoyer mon retour'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
